import { ensureNoUndefinedProperties } from '@/Shared/Helper/EnsureNoUndefinedProperties'

export default class CompanyUserID {
    constructor(public readonly value: number) {
        ensureNoUndefinedProperties(this)
    }
}
